import { IMostDecoratedApi } from '../types';
import Core from '@mediaplatform/sportal365-football-sdk-v2';

export default (sdk: Core): IMostDecoratedApi => {
  const getMostDecorated: IMostDecoratedApi['getMostDecorated'] = ({ signal, dataSeason, dataLimit, dataStartPosition }) => {
    if (dataSeason) {
      const mostDecorated = sdk.decoratedPlayers({
        seasonId: dataSeason,
        startFromPosition: dataStartPosition,
        limitPlayers: dataLimit,
      });

      if (!mostDecorated) return;

      return mostDecorated.get({ signal });
    }

    console.warn('You must provide a valid season id.');
  };
  return { getMostDecorated };
};
